/**************************************************
 * Nombre:       Home_Contactos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {CONTACTOS, LAT, LONG, NEGRITA} from "../../../Constantes";
import {theme} from "../../../Tema";
import {irMapa} from "../../../Utilidades/irMapa";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Home_Contactos = () => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={4}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 5}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={0}
                            >

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: sCell ? 'center' : 'flex-start'}}>
                                    <Typography
                                        sx={{
                                            fontFamily: NEGRITA,
                                            fontSize: sCell ? 40 : 48,
                                            fontWeight: 600,
                                            color: theme.palette.primary.main,
                                            textAlign: sCell ? 'center' : 'left'
                                        }}>Contactos</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography
                                        sx={{
                                            fontSize: sCell ? 16 : 18,
                                            fontWeight: 400,
                                            textAlign: sCell ? 'center' : 'left'
                                        }}>
                                        Ubicación Estratégica en el Centro de Tumaco Nos encontramos en la calle
                                        Bolívar, diagonal a la Casa de la Cultura. Disfruta de la cercanía a la zona
                                        comercial de Tumaco y de un acceso rápido a la playa El Morro y los muelles para
                                        el avistamiento de ballenas. La ubicación ideal para conocer lo mejor de Tumaco.
                                    </Typography>
                                </Grid>

                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}
                                    sx={{mt: 2}}
                                >

                                    {CONTACTOS.map((item, index) => (
                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start', mt: 1}}>
                                            <Typography
                                                sx={{fontSize: 18, fontWeight: 600, lineHeight: 1.2, color: '#080A44'}}>
                                                <span>
                                                <img src={item.img} width={12} height={'auto'}
                                                     style={{marginRight: 6}}/>
                                                </span>

                                                {item.descripcion}
                                            </Typography>
                                        </Grid>
                                    ))}

                                </Grid>

                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}
                                    spacing={2}
                                    sx={{mt: 3}}
                                >

                                    <Button sx={{boxShadow: 0}}>
                                        RESERVAR HABITACION
                                    </Button>

                                    <Button
                                        onClick={() => irMapa({lat: LAT, long: LONG})}
                                        variant={'outlined'}>
                                        LLEVAME
                                    </Button>

                                </Grid>

                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 7}} sx={{justifyContent: 'flex-end'}}>
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1639.1838973397075!2d-78.76734764258671!3d1.8050060748584515!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e2d020da17fe8af%3A0x716c8333152bd5f8!2sHotel%20Mar%20Azul!5e0!3m2!1ses!2sco!4v1770149920966!5m2!1ses!2sco"
                                width={!masSM ? '100%' : '90%'} height="450" style={{border: 0, borderRadius: 10}}
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"></iframe>
                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Contactos